import type { Breakpoint, SxProps, Theme } from "@mui/material/styles";

import Alert from "@mui/material/Alert";
import { HeaderSection } from "app/layout/components/HeaderSection";
import { LayoutSection } from "app/layout/components/LayoutSection";
import { stylesMode } from "app/theme/data";

import { AuthLayoutContent } from "./AuthLayoutContent";

export type AuthLayoutProps = {
  children: React.ReactNode;
  header?: {
    sx?: SxProps<Theme>;
  };
  sx?: SxProps<Theme>;
};

export function AuthLayout({ children, header, sx }: AuthLayoutProps) {
  const layoutQuery: Breakpoint = "md";

  return (
    <LayoutSection
      cssVars={{ "--layout-auth-content-width": "420px" }}
      footerSection={null}
      headerSection={
        <HeaderSection
          layoutQuery={layoutQuery}
          slotProps={{
            container: { maxWidth: false },
            toolbar: {
              sx: { backdropFilter: "unset", bgcolor: "transparent" },
            },
          }}
          slots={{
            topArea: (
              <Alert severity="info" sx={{ borderRadius: 0, display: "none" }}>
                This is an info Alert.
              </Alert>
            ),
          }}
          sx={{
            position: { [layoutQuery]: "fixed" },

            ...header?.sx,
          }}
        />
      }
      sx={{
        "&::before": {
          backgroundImage: `url(/assets/background/overlay.jpg)`,
          backgroundPosition: "center center",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          content: "''",
          height: 1,
          opacity: 0.24,
          position: "fixed",
          [stylesMode.dark]: { opacity: 0.08 },
          width: 1,
          zIndex: -1,
        },
        ...sx,
      }}
    >
      <AuthLayoutContent layoutQuery={layoutQuery}>
        {children}
      </AuthLayoutContent>
    </LayoutSection>
  );
}
